// src/components/VisitorsChartComponent.jsx
import React from "react";
import { Line } from "react-chartjs-2";

const VisitorsChartComponent = ({ data, options, }) => {
  return (
    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default VisitorsChartComponent;
